import { TerceraChart } from '../../../Chart/TerceraChart';
import { BaseChartRactive } from './BaseChartRactive';

export class TerceraChartRactive extends BaseChartRactive<TerceraChart> {
    public override createChart (): TerceraChart {
        return new TerceraChart(this.context, this.get('terceraChartPanelContext'));
    }
}
